var detect = avm.require('avast.detect');
var detecting = detect(); //Browser and OS detection, return following object

if (detecting.os.isWindows && detecting.os.version === 'XP') {
	$('body').addClass('detected-xp');
} else if (detecting.os.isWindows && detecting.os.version === 'Vista') {
	$('body').addClass('detected-vista');
} else {
	$('body').addClass('detected-other');
}
